import accessManagement from "./accessManagement.json";
import accountCenter from "./accountCenter.json";
import common from "./common.json";
import devicesGroups from "./devicesGroups.json";
import home from "./home.json";
import login from "./login.json";
import subscribeServices from "./subscribeServices.json";
import groupUser from "./groupUser.json";
import store from "./store.json";
import nubisDrive from "./nubisDrive.json";
import mixins from "../mixins/zh_cn";
import mixins_extra from "../mixins/zh_cn.extra";
import error from "./error.json";

export const zh_cn = {
  accessManagement,
  accountCenter,
  common,
  devicesGroups,
  home,
  login,
  subscribeServices,
  groupUser,
  store,
  nubisDrive,
  error,
  ...mixins,
  ...mixins_extra
};
